import React, { useState } from 'react';
import { dossiers as apiDossiers } from '../services/api';
import { useNdf } from '../NdfContext';

// Rangée de pastilles « Dossier » : les dossiers ouverts de l'utilisateur,
// « Aucun », et la création inline (« + Nouveau ») sans quitter la fiche.
function SelecteurDossier({ valeur, onChange, disabled }) {
  const { dossiers, rechargerDossiers } = useNdf();
  const [creation, setCreation] = useState(false);
  const [libelle, setLibelle] = useState('');

  const visibles = dossiers.filter((d) => d.statut === 'ouvert' || d.id === valeur);

  const creer = async () => {
    const nom = libelle.trim();
    if (!nom) { setCreation(false); return; }
    try {
      const res = await apiDossiers.creer(nom);
      rechargerDossiers();
      onChange(res.data.dossier.id);
      setCreation(false);
      setLibelle('');
    } catch {
      setCreation(false);
    }
  };

  return (
    <div className="fd-champ">
      <span>Dossier</span>
      <div className="fd-chips">
        <button type="button" disabled={disabled}
          className={`fd-chip ${valeur === null ? 'active' : ''}`}
          onClick={() => onChange(null)}>Aucun</button>
        {visibles.map((d) => (
          <button key={d.id} type="button" disabled={disabled}
            className={`fd-chip ${valeur === d.id ? 'active' : ''}`}
            onClick={() => onChange(d.id)}>
            📁 {d.libelle}{d.statut === 'clos' ? ' (clos)' : ''}
          </button>
        ))}
        {!disabled && !creation && (
          <button type="button" className="fd-chip fd-chip--creer" onClick={() => setCreation(true)}>+ Nouveau</button>
        )}
      </div>
      {creation && (
        <div className="fd-dossier-creation">
          <input
            type="text"
            autoFocus
            placeholder="ex. Déplacement Guadeloupe"
            value={libelle}
            maxLength={120}
            onChange={(e) => setLibelle(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') creer(); if (e.key === 'Escape') setCreation(false); }}
          />
          <button type="button" className="nf-btn nf-btn--principal" onClick={creer}>Créer</button>
        </div>
      )}
    </div>
  );
}

export default SelecteurDossier;
